import { forwardRef } from 'react'
import { GenIcon, IconTree } from 'react-icons'
import { getIcon } from './iconMappings'

interface IconProps {
  icon: string
  fill?: string
  className?: string
  style?: React.CSSProperties
  size?: string
  'aria-hidden'?: React.AriaAttributes['aria-hidden']
}

// provided a default color picked from _variables.scss as mentioned in the designs
// forwardRef is required so Radix UI's asChild/Slot pattern doesn't warn about
// function components receiving refs. The ref itself cannot be forwarded to the
// underlying SVG because react-icons v4 does not use forwardRef internally.
const Icon = forwardRef<SVGSVGElement, IconProps>(
  ({ fill = '#0d85f4', icon, ...rest }, _ref) => {
    const IconValue = getIcon(icon)

    // Checks if icon is a custom json or from react-icons
    return typeof IconValue == 'function' ? (
      <IconValue fill={fill} color={fill} {...rest} />
    ) : (
      GenIcon(IconValue as IconTree)({ fill, color: fill, ...rest })
    )
  }
)

Icon.displayName = 'Icon'

export default Icon
